import React, {useEffect, useState} from 'react'
import CompanyName from './Component/CompanyName';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import UVPrintingImage from './Images/UVPrinting.jpg';
import ScreenPrintingImage from './Images/ScreenPrinting.jpg';
import HotStampPrintingImage from './Images/HotStampPrinting.jpg';
import ThermalDecalPrintingImage from './Images/ThermalDecalPrinting.jpg'



const Home = () => {

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


   const ServiceImages = {
    "Hot Stamp Printing": HotStampPrintingImage,
    "UV Printing": UVPrintingImage,
    "Screen Printing" : ScreenPrintingImage,
    "Thermal Decal Printing": ThermalDecalPrintingImage,
    
  };

    useEffect(() => {
      const loadServices = async () => {
        try {
          // Load services from Services.json in public folder
          const response = await fetch('/Services.json');
          
          if (!response.ok) {
            throw new Error('Failed to load services');
          }
          
          const data = await response.json();
          setServices(data);
          setLoading(false);
        } catch (err) {
          console.error('Error loading services:', err);
          setError('Failed to load services');
          setLoading(false);
        }
      };
  
      loadServices();
    }, []);

  return (
   <div className='max-w-[1200px] mx-auto px-8'>

            
                <title>Gotenberg Solution, premier printing specialist</title>
                <meta name="keywords" content="printing specialist Cairo, Egypt" />
                <meta property="og:title" content="Gotenberg Solution, premier printing specialist" />
               
                <meta  property="og:url" content="https://gotenbergsolution.com/" />
               
                <meta  property="og:description" content="Since 1985, Gotenberg Solution delivers top-tier printing & labels for brands. From tableware to packaging, we ensure premium quality & craftsmanship." />

            
<section>

    <h1 className='text-2xl font-bold pt-12 pb-4'>Welcome to <CompanyName/></h1>





      <h2 className='text-xl font-bold pb-4'>Printing & Labels: Our Story</h2>

<div>
<p><CompanyName/> Printing & Labels began its journey in 1985 when its founder, Mahmoud Abul Nawas, leveraged his expertise in printing and design to establish a specialized printing company.</p>
<p className='py-4'>As a premier printing specialist, <CompanyName/> offers professional, high-quality printing services across an extensive range of products including tableware, mugs, plates, serving trays, textiles, coffee packaging, cosmetic packaging, and more.</p>
<p>At <CompanyName/>, we are committed to delivering innovative, premium-quality printing and labeling solutions that not only meet but exceed our clients' expectations. We take pride in providing exceptional services and products that authentically reflect our clients' brand identity and aesthetic preferences.</p>
</div>

</section>

<div>

{/* <div className='lg:float-left lg:mr-10 my-8'><img src={TempImage} alt='' title='' className=''/></div> */}

<div className='mx-16'>
  <section>
    <h2 className='text-lg font-bold pb-4 pt-8'>Our Vision</h2>
    <p className='pb-4'>To become the industry leader in printing and labeling by:</p>

<ul className="list-disc list-inside space-y-2 pl-5">
  <li>Delivering superior, innovative printing solutions</li>
  <li>Building lasting client partnerships through exceptional service</li>
  <li>Upholding uncompromising standards in:
    <ul className="list-disc list-inside pl-5 mt-2 space-y-1">
      <li>Premium quality assurance</li>
      <li>Cutting-edge innovation</li>
      <li>Client-first approach</li>
      <li>Artisanal craftsmanship</li>
      <li>Timely project execution</li>
      <li>Market-competitive value</li>
    </ul>
  </li>
</ul>
</section>

<section>
    <h2 className='text-lg font-bold pb-4 pt-8'>Overcoming Challenges</h2>
    <p className='pb-4'>In our early years, we faced significant obstacles including:</p>

    <ul className="list-disc list-inside space-y-2 pl-5">
        <li>Intense market competition from established industry players</li>
        <li>Limited financial resources</li>
    </ul>
    <p className='py-4'>Despite these challenges, <CompanyName/> achieved success through:</p>

    <ul className="list-disc list-inside space-y-2 pl-5">
        <li><span className='font-bold'>Quality Focus</span>: Prioritizing exceptional printing standards</li>
    <li><span className='font-bold'>Innovative Solutions:</span> Developing creative approaches to meet client needs</li>
    <li><span className='font-bold'>Dedicated Teamwork</span>: Our staff's relentless commitment to excellence</li>
    </ul>

    <p className='pt-4'>Today, our perseverance has positioned <CompanyName/> as a trusted partner for businesses seeking premium printing solutions.

</p>
</section>


<section>
  <h2 className='text-lg font-bold pb-4 pt-8'>Our Services</h2>

<div className='lg:grid lg:grid-cols-4 lg:gap-4'>
   {services.map((service) => (
    <div className='mx-auto'>
      <div className='font-bold pb-4'>{service.ServiceName}</div>
      <div className='mb-4'>
        <a href={service.ServiceLink}><img src={ServiceImages[service.ServiceName]} alt='' title={service.ServiceName} className='rounded-3xl'/></a>
      </div>
      <div className='text-right'><a className="inline-flex items-center gap-1 hover:underline" href={service.ServiceLink}><span>	Learn More</span> <span><MdKeyboardDoubleArrowRight/></span></a></div>
      
      </div>


   ))}
</div>
</section>

</div>
</div>
   </div>
  )
}

export default Home
